module.exports = __webpack_public_path__ + "img/emo_13.a05ba513.png";